import z from "zod"

export type DocumentsVisibility = "user" | "tenant" | "global"

export const VISIBILITY_LABELS: Record<DocumentsVisibility, string> = {
  user: "Private",
  tenant: "Team",
  global: "Public",
}

const STORAGE_KEY = "documents-preferences"

const DEFAULT_VISIBILITY: DocumentsVisibility = "user"

const preferencesSchema = z
  .object({
    visibility: z.enum(["user", "tenant", "global"]).catch(DEFAULT_VISIBILITY),
  })
  .catch({ visibility: DEFAULT_VISIBILITY })

export function readDocumentsVisibility(): DocumentsVisibility {
  try {
    return preferencesSchema.parse(
      JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "null"),
    ).visibility
  } catch {
    return DEFAULT_VISIBILITY
  }
}

export function writeDocumentsVisibility(
  visibility: DocumentsVisibility,
): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ visibility }))
}
